import {For, onMount} from 'solid-js'
import {clearOauthData, loginTvService, logout} from '@te_react/volt-store/lib/actions'
import {useIcon} from '../icon/useIcon'
import {useDispatch} from '../../store'
import {getDeviceData, isWeb} from '../../utils'
import {FocusGroupProvider, FocusableProvider} from '../focus/index'
import { useSpatialNavigation } from '../../spatialNavigation'
import { useI18n } from '../../i18n'

interface SubscriptionSelctorProps {
    services: any
    onClose?: () => any
}
export const SubscriptionSelector = (props: SubscriptionSelctorProps) => {
    const icons = useIcon()
    const dispatch = useDispatch()
    const { setFocus } = useSpatialNavigation()
    const {getI18n} = useI18n() 

    const CloseIcon = icons.get('Close')
    const BackgroundImage = icons.get('BackgroundImage')

    const onServiceSelection = (service: any) => {
        dispatch(loginTvService({serviceId: service.serviceId, deviceData: getDeviceData()}))
    }

    onMount(() => {
        !isWeb && setFocus(`tvid-focus-item-${props?.services?.[0]?.serviceId}`)
    })

    const onCancel = () => {
        window.location.href = '/'
        // localStorage.clear() - Do not clear all the storage, this is not a good way to logout as there are some key that should remain
        dispatch(logout({onSuccess: () => {}}))
        dispatch(clearOauthData())
    }

    return (
        <FocusGroupProvider id={`tvid-selection-form-screen`} focusKey={`tvid-selection-form-screen`}>
            <div class="selectorWrapper">
                <BackgroundImage class="selectorBackground" />
                <div class={`${isWeb ? 'selectorModalWrapper' : 'selectorModalWrapperTv'}`}>
                    {isWeb && <div class="selectorHeader">
                        <div class={`${isWeb ? 'selectTv' : 'selectorTitleTv'}`}>{getI18n()?.formatMessage({id:"MULTIPLE_SUBSCRIPTION_TITLE"})}</div>
                        <CloseIcon onClick={onCancel} class="selectorCrossIcon" />
                    </div>}
                    <div class={`${isWeb ? 'selectorSubTitle' : 'selectorSubTitleTv'}`}>
                        {getI18n()?.formatMessage({id:"MULTIPLE_SUBSCRIPTION_DESC"})}
                    </div>
                    <For each={props?.services}>
                        {(service: any) => 
                            <FocusableProvider
                                id={`tvid-focus-item-${service?.serviceId}`}
                                focusKey={`tvid-focus-item-${service?.serviceId}`}
                                onEnterPress={() => {
                                    onServiceSelection(service)
                                    props.onClose && props?.onClose()
                                }}
                            >
                                {(focused: any) => (
                                    <div
                                        onClick={() => {
                                            onServiceSelection(service)
                                        }}
                                        class={`${isWeb ? 'selectorTVID' : `selectorTVID_TV ${focused?.() ? 'selectorTVID_TVFocused' : ''}` }`}
                                    >
                                        {service?.serviceId}
                                    </div>
                                )}
                            </FocusableProvider>
                        }
                    </For>
                </div>
            </div>
        </FocusGroupProvider>
    )
}
